import { render, staticRenderFns } from "./LayoutSidebarLeftCollapseIcon.vue?vue&type=template&id=1e3e2113&lang=pug"
import script from "./LayoutSidebarLeftCollapseIcon.vue?vue&type=script&lang=js"
export * from "./LayoutSidebarLeftCollapseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports